module.exports = __webpack_public_path__ + "static/HeaderVideo-a6bdd4b3ebe6f7070739f5482d929d5d.mp4";